import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocationContextService } from '@core/tenant/location-context.service';
import { SKIP_TENANT_HEADERS } from '@core/http/public-catalog-http.context';

export const tenantLocationInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_TENANT_HEADERS)) {
    return next(req);
  }

  const locationId = inject(LocationContextService).activeLocationId();
  if (!locationId) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'X-Location-Id': String(locationId),
      },
    })
  );
};
